export function audioWarnings(
    devices: MediaDeviceInfo[],
    supportsOutput: boolean
): { noAudioInput: boolean; noAudioOutput: boolean } {
    // Enumeracji ufamy TYLKO gdy widać etykiety urządzeń (= przyznane uprawnienia
    // do mediów). Bez uprawnień Firefox w ogóle nie wystawia 'audiooutput'
    // (mimo że setSinkId istnieje), a Chrome przycina listę — stąd fałszywy
    // alarm "brak głośników" u osób, które normalnie prowadzą rozmowy.
    const enumerationTrusted = devices.some(d => !!d.label);
    return {
        noAudioInput: devices.filter(d => d.kind === 'audioinput').length === 0,
        noAudioOutput: supportsOutput && enumerationTrusted
            ? devices.filter(d => d.kind === 'audiooutput').length === 0
            : false
    };
}
